import { createAsyncThunk } from "@reduxjs/toolkit";

import { enqueueSnackbarErrorAlert } from "@/components/pages/common/snackbar-alert/EnqueueSnackbarErrorAlert";
import { RootState } from "@/store/store";
import { updateSavingsOpportunityViewThunk } from "@/store/savings-opportunities/thunks/views-hierarchy/actions/updateSavingsOpportunityViewThunk";
import { savingsOpportunityCurrentViewConfigSelector } from "@/store/savings-opportunities/selectors/views-hierarchy/current-view/savingsOpportunityCurrentViewConfigSelector";

export const updateSavingsOpportunityCurrentViewGridStateThunk =
  createAsyncThunk(
    "savingsOpportunities/updateSavingsOpportunityCurrentViewGridState",
    async (
      { gridConfig, viewId }: { gridConfig: string; viewId: string },
      { dispatch, getState },
    ) => {
      const state = getState() as RootState;

      const config = savingsOpportunityCurrentViewConfigSelector(state);

      try {
        return await dispatch(
          updateSavingsOpportunityViewThunk({
            viewId: viewId,
            body: { config: { ...config, gridConfig } },
          }),
        ).unwrap();
      } catch (e) {
        // @ts-expect-error todo: fix api spec;
        enqueueSnackbarErrorAlert(e?.data?.message);
      }
    },
  );
